import React, { useEffect, useState } from 'react'
import ParkingBox from './ParkingBox'
import { useReservationContext } from './ReservationContext'
import Loader from '../search-trip/components/Loader'
import moment from 'moment'

const Parkings = () => {
    const {
        offer,
        parkingAirports,
        parkingOffers,
        getParkingAirports,
        getParkingOffers,
        selectedParkingAirport,
        setSelectedParkingAirport,
        selectedParkingOffer,
        setSelectedParkingOffer,
        showSearchBoxForParking,
        t
    } = useReservationContext()

    useEffect(() => {
        if (offer && offer.length > 0) {
            getParkingAirports()
        }
    }, [offer])

    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)

    const handleStartClick = (day, modifiers, e) => {
        const clickedDate = moment(day);
        const clickedFormatted = clickedDate.format('YYYY-MM-DD');

        setStartDate(null);
    };

    const handleEndClick = (day, modifiers, e) => {
        const clickedDate = moment(day);
        const clickedFormatted = clickedDate.format('YYYY-MM-DD');

        setEndDate(null);
    };

    if (!parkingAirports && offer && offer.length > 0) return <Loader />

    return (
        <div className="trip-reservation__section trip-reservation__section--full">
            <div className="trip-reservation__section-headings">
                <div className="trip-reservation__section-heading">{t('parking-title')}</div>
                <div className="trip-reservation__section-subheader">{t('parking-description')}</div>
            </div>

            {showSearchBoxForParking  && (
                <div className="trip-reservation__parking-search">
                    <div className="trip-reservation__parking-search-heading">{t('parking-chose-airport-description')}</div>
                    <label  className="trip-reservation__parking-search-label">
                        {t('parking-chose-airport')}
                        <select value={selectedParkingAirport} onChange={(e) => setSelectedParkingAirport(e.target.value)} className="trip-reservation__select">
                            <option key={0} value={null}>
                                {t('parking-chose-airport')}
                            </option>
                            {parkingAirports.map((airport) => (
                                <option key={airport.id} value={airport.id} >
                                    {airport.name}
                                </option>
                            ))}
                        </select>
                    </label>
                    <button
                        className={`trip-reservation__btn trip-reservation__btn--summary ${
                            !selectedParkingAirport ? 'trip-reservation__btn-disabled' : ''
                        }`}
                        disabled={!selectedParkingAirport}
                        onClick={() => getParkingOffers(selectedParkingAirport)}
                    >
                        {t('parking-search')}
                    </button>
                </div>
            )}

            <div className="trip-reservation__parkings">
                {parkingOffers && parkingOffers.map((parkingOffer) => (
                    <ParkingBox parkingOffer={parkingOffer}/>
                ))}
            </div>
        </div>
    )
}

export default Parkings